module.exports = __webpack_public_path__ + "img/test1.6e3dda02.png";